import { Close } from '@mui/icons-material';
import { Chip, IconButton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import type {
    CustomServiceRejection,
    CustomServiceSuggestion,
} from './useCustomServiceValidation';

type CustomServiceFeedbackProps = {
    rejection: CustomServiceRejection | null;
    suggestion: CustomServiceSuggestion | null;
    validating: boolean;
    onAcceptSuggestion: () => void;
    onDismiss: () => void;
};

const CustomServiceFeedback = ({
    rejection,
    suggestion,
    validating,
    onAcceptSuggestion,
    onDismiss,
}: CustomServiceFeedbackProps) => {
    const theme = useTheme();

    if (!rejection && !suggestion) return null;

    return (
        <Stack
            direction='row'
            spacing={1}
            alignItems='center'
            flexWrap='wrap'
            useFlexGap
        >
            {rejection ? (
                <Typography variant='caption' sx={{ color: 'error.main' }}>
                    {rejection.reason}
                </Typography>
            ) : null}
            {suggestion ? (
                <>
                    <Typography variant='caption' color='text.secondary'>
                        Did you mean
                    </Typography>
                    <Chip
                        label={suggestion.suggested}
                        size='small'
                        variant='outlined'
                        disabled={validating}
                        onClick={onAcceptSuggestion}
                        sx={{
                            cursor: 'pointer',
                            borderColor: theme.palette.textAccent.main,
                            color: theme.palette.textAccent.main,
                            fontWeight: 600,
                        }}
                    />
                </>
            ) : null}
            <IconButton
                size='small'
                onClick={onDismiss}
                aria-label='Dismiss service suggestion'
            >
                <Close sx={{ fontSize: 14 }} />
            </IconButton>
        </Stack>
    );
};

export default CustomServiceFeedback;
